import React from "react";
import bg_img from "../../assets/analytics/bg_img.jpg";
import ml from "../../assets/analytics/machine-learning.png";
import nlp from "../../assets/analytics/nlp.png";
import computerVision from "../../assets/analytics/ai-icon-03.png";
import forecasting from "../../assets/analytics/forecasting.png";
import automation from "../../assets/analytics/ai-icon-02.png";
import chatbot from "../../assets/analytics/chatbot.png";

const services = [
  {
    icon: chatbot,
    title: "AI-Powered Chatbots",
    description:
      "Intelligent conversational agents that handle customer queries across web, mobile, and voice channels. With context-aware responses and seamless CRM integration, they cut response times, boost satisfaction, and enable round-the-clock support.",
    scale: 1,
  },
  {
    icon: automation,
    title: "Human Capacity Augmentation",
    description:
      "AI tools that amplify team productivity by automating routine tasks and delivering real-time assistance. From workflow automation to decision support, this approach improves efficiency, reduces errors, and helps teams focus on higher-value work.",
    scale: 1,
  },
  {
    icon: nlp,
    title: "Natural Language Processing",
    description:
      "NLP-driven systems that understand, interpret, and generate human language at scale. Used for sentiment analysis, document summarization, and intelligent search, it turns unstructured text into actionable business insights.",
    scale: 1,
  },
  {
    icon: forecasting,
    title: "Predictive Analytics & Forecasting",
    description:
      "Machine learning models that analyze historical trends to forecast demand, revenue, and risk. Organizations use these insights to plan proactively, optimize inventory, and make confident, data-backed strategic decisions.",
    scale: 1,
  },
  {
    icon: ml,
    title: "Machine Learning Models",
    description:
      "Custom-built models that learn from your data to automate classification, recommendations, and anomaly detection. These self-improving systems get smarter over time, delivering increasingly accurate results.",
    scale: 1,
  },
  {
    icon: computerVision,
    title: "AI-Powered Customer Analytics",
    description:
      "Data-driven insights into customer behavior through segmentation, journey mapping, and churn prediction. These analytics help improve retention, personalize experiences, and optimize marketing spend effectively.",
    scale: 1,
  },
];

const Analytics_services = () => {
  return (
    <div id="solutions" className="py-10">
      <div>
        <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
          Powering Every Business Function with Intelligent AI Solutions...
        </p>

        <div className="px-4 sm:px-10 mt-12 grid grid-cols-1 sm:grid-cols-3 gap-x-8 gap-y-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center font-notosans"
            >
              <div className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center mb-4 overflow-hidden">
                <img
                  src={service.icon}
                  className="max-w-full max-h-full object-contain"
                  style={{ transform: `scale(${service.scale})` }}
                  alt={service.title}
                />
              </div>
              <h3 className="font-bold text-base sm:text-lg text-[#333e49] mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed text-justify px-2">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Analytics_services;